import type { Loan, StaffMember } from '../types/commission'

export const runPeriod = {
  label: 'September 2026',
  tierBasisLabel: 'August 2026 closings',
}

export const staff: StaffMember[] = [
  { id: 's1', name: 'Dana Whitfield', role: 'LO', priorMonthLoans: 7 },
  { id: 's2', name: 'Marcus Ellery', role: 'LO', priorMonthLoans: 4 },
  { id: 's3', name: 'Priya Raman', role: 'LO', priorMonthLoans: 2 },
  { id: 's4', name: 'Hal Brenner', role: 'LO', priorMonthLoans: 5 },
  {
    id: 's5',
    name: 'Tomás Vega',
    role: 'LOA',
    priorMonthLoans: 0,
    flatBps: 85,
    hasHourlyComponent: true,
  },
  { id: 's6', name: 'Jenna Cole', role: 'LOA', priorMonthLoans: 0, flatBps: 75 },
]

export const loans: Loan[] = [
  {
    id: 'l1',
    fileNumber: '24-10841',
    borrower: 'Okafor, R.',
    state: 'OH',
    closedOn: '2026-09-03',
    loanAmount: 420000,
    ysplDollars: 11800,
    originationFee: 0,
    discountPoints: 0,
    processingFeeCollected: 1995,
    underwritingFeeCollected: 0,
    applicationFeeCollected: 0,
    toleranceCure: 0,
    participants: [{ staffId: 's1' }, { staffId: 's6' }],
  },
  {
    id: 'l2',
    fileNumber: '24-10852',
    borrower: 'Delgado, M. & A.',
    state: 'PA',
    closedOn: '2026-09-05',
    loanAmount: 310000,
    ysplDollars: 9300,
    originationFee: 0,
    discountPoints: 0,
    processingFeeCollected: 1995,
    underwritingFeeCollected: 0,
    applicationFeeCollected: 0,
    toleranceCure: 0,
    participants: [{ staffId: 's2' }, { staffId: 's5' }],
  },
  {
    id: 'l3',
    fileNumber: '24-10866',
    borrower: 'Chen, W.',
    state: 'NJ',
    closedOn: '2026-09-09',
    loanAmount: 385000,
    ysplDollars: 11000,
    originationFee: 900,
    discountPoints: 0,
    processingFeeCollected: 0,
    underwritingFeeCollected: 0,
    applicationFeeCollected: 1995,
    toleranceCure: 0,
    participants: [{ staffId: 's1' }, { staffId: 's5' }],
  },
  {
    id: 'l4',
    fileNumber: '24-10879',
    borrower: 'Whitmore, T.',
    state: 'NC',
    closedOn: '2026-09-11',
    loanAmount: 460000,
    ysplDollars: 15800,
    originationFee: 0,
    discountPoints: 0,
    processingFeeCollected: 0,
    underwritingFeeCollected: 1995,
    applicationFeeCollected: 0,
    toleranceCure: 0,
    participants: [{ staffId: 's4' }, { staffId: 's6' }],
  },
  {
    id: 'l5',
    fileNumber: '24-10884',
    borrower: 'Ruiz, S.',
    state: 'OH',
    closedOn: '2026-09-15',
    loanAmount: 295000,
    ysplDollars: 8900,
    originationFee: 0,
    discountPoints: 0,
    processingFeeCollected: 1995,
    underwritingFeeCollected: 0,
    applicationFeeCollected: 0,
    toleranceCure: 650,
    participants: [{ staffId: 's3' }, { staffId: 's6' }],
  },
  {
    id: 'l6',
    fileNumber: '24-10890',
    borrower: 'Abramson, L.',
    state: 'MI',
    closedOn: '2026-09-18',
    loanAmount: 350000,
    ysplDollars: 10200,
    originationFee: 0,
    discountPoints: 0,
    processingFeeCollected: 1195,
    underwritingFeeCollected: 0,
    applicationFeeCollected: 0,
    toleranceCure: 0,
    participants: [{ staffId: 's2' }, { staffId: 's5' }],
  },
  {
    id: 'l7',
    fileNumber: '24-10902',
    borrower: 'Nakamura, K.',
    state: 'OH',
    closedOn: '2026-09-22',
    loanAmount: 525000,
    ysplDollars: 14600,
    originationFee: 1800,
    discountPoints: 0,
    processingFeeCollected: 1995,
    underwritingFeeCollected: 0,
    applicationFeeCollected: 0,
    toleranceCure: 0,
    participants: [{ staffId: 's1' }, { staffId: 's6' }],
  },
  {
    id: 'l8',
    fileNumber: '24-10911',
    borrower: 'Patel, D.',
    state: 'PA',
    closedOn: '2026-09-25',
    loanAmount: 268000,
    ysplDollars: 7600,
    originationFee: 0,
    discountPoints: 1340,
    processingFeeCollected: 1995,
    underwritingFeeCollected: 0,
    applicationFeeCollected: 0,
    toleranceCure: 300,
    participants: [{ staffId: 's3' }, { staffId: 's5' }],
  },
]
